import { ReactElement, useMemo } from 'react'
import StartAndEndTimeTemplate from './template'
import { useSteps } from '../../../../contexts/stepContext'
import { reduceTimeOptions } from './reduceTimeOptions'
import { ITimeOption } from '../../../../types/interfaceextension'
import { useBFSMValue } from '../../../../services/hooks/useBFSMValues'
import {
    CompanyActions,
    CompanyLeadState,
} from '@raskrask-dk/bookingflow-state-machine'

const StartAndEndTimePage = (): ReactElement => {
    const [currentStep, helpers] = useSteps()

    const [companySettings, setCompanySettings] = useBFSMValue<
        CompanyLeadState,
        CompanyActions.SetCompanySettings,
        'companySettings'
    >('companySettings', CompanyActions.SetCompanySettings)

    const defaultTimeSlots = useMemo(() => {
        const timeOptionsArray: ITimeOption[] = []
        for (let i = 6; i < 21; i++) {
            const time = `${i}:00`.padStart(5, i < 10 ? '0' : '')
            timeOptionsArray.push({
                label: time,
                value: time,
            })
        }
        return timeOptionsArray
    }, [])

    const onChangeStart = (value?: string) =>
        setCompanySettings({
            ...companySettings,
            wantedFromTime: value,
        })

    const onChangeFinish = (value?: string) =>
        setCompanySettings({
            ...companySettings,
            wantedToTime: value,
        })

    const fromTimeOptions: ITimeOption[] = reduceTimeOptions(
        defaultTimeSlots,
        'Before',
        companySettings?.wantedToTime
    )
    const toTimeOptions: ITimeOption[] = reduceTimeOptions(
        defaultTimeSlots,
        'After',
        companySettings?.wantedFromTime
    )

    return (
        <StartAndEndTimeTemplate
            currentStep={currentStep}
            dataCy="accordion-startandend"
            fromTimeOptions={fromTimeOptions}
            helpers={helpers}
            onChangeFinish={onChangeFinish}
            onChangeStart={onChangeStart}
            toTimeOptions={toTimeOptions}
            wantedFromTime={companySettings?.wantedFromTime}
            wantedToTime={companySettings?.wantedToTime}
        />
    )
}

export default StartAndEndTimePage
